import {ShadowPanel} from "../ShadowJsonViewer"

interface ShadowTabsPanelProps {
	macAddress: string
	shadowClassic: any
	shadowRadar: any
	activeTab: "classic" | "radar"
	onSetActiveTab: (tab: "classic" | "radar") => void
}

export const ShadowTabsPanel = ({
	macAddress,
	shadowClassic,
	shadowRadar,
	activeTab,
	onSetActiveTab,
}: ShadowTabsPanelProps) => (
	<div className="space-y-4">
		<div className="border-b border-gray-200 dark:border-gray-700">
			<nav className="-mb-px flex space-x-8">
				<button
					onClick={() => onSetActiveTab("classic")}
					className={`py-2 px-1 border-b-2 font-medium text-sm ${
						activeTab === "classic"
							? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
							: "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-500"
					}`}>
					Shadow Classic
				</button>
				<button
					onClick={() => onSetActiveTab("radar")}
					className={`py-2 px-1 border-b-2 font-medium text-sm ${
						activeTab === "radar"
							? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
							: "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-500"
					}`}>
					Shadow Radar
				</button>
			</nav>
		</div>
		<div className="mt-4">
			{activeTab === "classic" && (
				<div>
					<h4 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-3">
						Classic Shadow Data
					</h4>
					<ShadowPanel data={shadowClassic} shadowType="default" deviceId={macAddress} />
				</div>
			)}
			{activeTab === "radar" && (
				<div>
					<h4 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-3">
						Radar Shadow Data
					</h4>
					<ShadowPanel data={shadowRadar} shadowType="radar" deviceId={macAddress} />
				</div>
			)}
		</div>
	</div>
)
